import { defineStore } from 'pinia'
import { computed } from 'vue'
import { usePreference } from '@/composables/usePreference'

export const usePreferencesStore = defineStore('preferences', () => {
  const {
    preference: firstTimeOpen,
    preferenceIsLoaded: firstTimeOpenIsLoaded,
  } = usePreference<boolean>('firstTimeOpen', true)

  const {
    preference: showedReplyTip,
    preferenceIsLoaded: showedReplyTipIsLoaded,
  } = usePreference<boolean>('showedReplyTip', false)

  const preferencesAreLoaded = computed<boolean>(() => firstTimeOpenIsLoaded.value && showedReplyTipIsLoaded.value)

  return {
    preferencesAreLoaded,
    firstTimeOpen,
    showedReplyTip,
  }
})
